/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

export const TopBundleFragment = {
  TopBundle: gql`
    fragment TopBundleQuery on topBundle_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      buttonScrollArrowDirection
      buttonScrollLabel
      buttonScrollStyle
      buttonScrollTo
      displayPrice
      hideGuaranteeLink
      lineBreak_content
      lineBreak_modals
      lineBreak_styles
      modalContent
      product {
        ...ProductEntry
      }
      productSeal {
        url
        ... on images_Asset {
          altText
        }
      }
      starCaption
      starRating
      styles
      topBundleBottomRightContent
      topBundleTopRightContent
      topProductContent
      topProductTitle
      typeHandle
    }
    ${ProductFragment.product}
  `,
};
